export default __webpack_public_path__ + "static/media/category_4.ac9a4b8f.png";